import React from 'react';
import FormMultiselect from '../FormMultiselect/FormMultiselect';
import { StateFacetItem } from '../../../ResultListSettings/ResultListSettings';
import { HeadingHierarchy } from '../../../../../_lib/components/Heading/Heading';
import { FormMultiselectModifier } from '../FormMultiselect/FormMultiselect';
import { FormMultiselectPanelModifier } from '../FormMultiselect/FormMultiselectPanel/FormMultiselectPanel';
import { CollapsibleOverlayModifier } from '../../../../organisms/CollapsibleOverlay/CollapsibleOverlay';
import { FilterButtonModifier } from '../../../ResultListSettings/partials/FilterButton';

type SelectALotType = {
  title: string;
  name: string;
  buttonHeadline?: string;
  hierarchy?: HeadingHierarchy;
  showButtons?: boolean;
  focusOnMount?: boolean;
  items?: StateFacetItem[];
  disableSubmitButton?: boolean;
  // Events
  onSubmit?: any;
  onChange?: any;
  onCloseResetFacet?: any;
  sortAphabetically?: boolean;
};

/**
 * SelectALot is a visual wrapper around FormMultiselect.
 * It passes through all functionality unchanged and only applies
 * additional CSS modifiers for styling purposes.
 */
export default function SelectALot({
  buttonHeadline,
  focusOnMount,
  hierarchy,
  disableSubmitButton,
  items,
  name,
  onChange,
  onSubmit,
  showButtons,
  title,
  onCloseResetFacet,
  sortAphabetically,
}: SelectALotType) {
  return (
    <FormMultiselect
      title={title}
      name={name}
      buttonHeadline={buttonHeadline}
      hierarchy={hierarchy}
      showButtons={showButtons}
      focusOnMount={focusOnMount}
      items={items}
      disableSubmitButton={disableSubmitButton}
      onSubmit={onSubmit}
      onChange={onChange}
      onCloseResetFacet={onCloseResetFacet}
      sortAphabetically={sortAphabetically}
      modifier={FormMultiselectModifier.WIDTH_100}
      buttonModifier={FilterButtonModifier.SELECT_A_LOT}
      collapsibleModifier={CollapsibleOverlayModifier.SELECT_A_LOT}
      panelModifier={FormMultiselectPanelModifier.SELECT_A_LOT}
    />
  );
}
